import { render, staticRenderFns } from "./CcicPunch.vue?vue&type=template&id=bdc29956&scoped=true"
import script from "./CcicPunch.vue?vue&type=script&lang=js"
export * from "./CcicPunch.vue?vue&type=script&lang=js"
import style0 from "./CcicPunch.vue?vue&type=style&index=0&id=bdc29956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc29956",
  null
  
)

export default component.exports